/**
 * Internal dependencies
 */
import { OBJECT_REPLACEMENT_CHARACTER } from './special-characters';
/** @typedef {import('./create').RichTextValue} RichTextValue */

/** @typedef {import('./create').RichTextFormat} RichTextFormat */

/**
 * Gets the active object, if there is any.
 *
 * @param {RichTextValue} value Value to inspect.
 *
 * @return {RichTextFormat|void} Active object, or undefined.
 */

export function getActiveObject(_ref) {
  let {
    start,
    end,
    replacements,
    text
  } = _ref;

  if (start + 1 !== end || text[start] !== OBJECT_REPLACEMENT_CHARACTER) {
    return;
  }

  return replacements[start];
}
//# sourceMappingURL=get-active-object.js.map